import React, { Component } from 'react';

export default class Err_Info_Display_Row extends Component {
	constructor(props) {
		super(props);

		this.state = {
		}

		this.device_name_cell = React.createRef();
	}

	render() {
		// Changed alignment for reports
		let span_style = {};
		let cell_height = 'unset';
		let device_name_height = 'unset';

		if (Object.keys(this.props.data).length <= 1) {
			span_style = {
				display: '-webkit-box',
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				WebkitLineClamp: 2,
				WebkitBoxOrient: 'vertical'
			}

			cell_height = 40;
			device_name_height = 40;
		} else {
			cell_height = 20;
			device_name_height = (42 * Object.keys(this.props.data).length) - 22;
		}

		return (
			<div style={this.props.row_style}>
				<div ref={this.device_name_cell} style={{ ...this.props.cell_style, height: device_name_height }}>
					<span style={span_style}>{this.props.point_info.name}</span>
				</div>
				<div style={{ display: 'inline-block' }}>
					{Object.keys(this.props.data).map((key) => {
						let val = this.props.data[key];

						return (
							<div>
								<div style={{ ...this.props.cell_style0, height: cell_height }}>
									<span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{key}</span>
								</div>
								<div style={{ ...this.props.cell_style0, height: cell_height }}>
									<span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{val}</span>
								</div>
							</div>
						)
					})}
				</div>
			</div>
		)
	}
}